<template>
	<div class="doc-abstract-info">
		<doc-basic-info-card
			v-if="basicInfoProps.curr_step_num>=stepInfo.stepNum"
			:card-title="'合同概况'"
			:edit-label="'编辑合同概况'"
			:info="basicCardLayout"
			@edit="onEdit"
			:can-edit="canEdit"
			:loading="loading"
		></doc-basic-info-card>
		<a-card v-else title="合同概况" :bordered="false" class="relative-doc-card" :loading="loading">
			<create-doc-form
				ref="createForm"
				class="doc-abstract-info-form"
				v-if="fieldOpts.length && createFormShow"
				:init-data="initNewData"
				:form-types="fieldOpts"
				@change="createDocChange"
			></create-doc-form>
		</a-card>
		<a-modal title="编辑合同概况" v-model="showEditModal" width="640px">
			<create-doc-form
				ref="editForm"
				v-if="fieldEditOpts.length>0 && showEditModal"
				:init-data="initData"
				:form-types="fieldEditOpts"
				@change="editDocChange"
			></create-doc-form>
			<template slot="footer">
				<a-button @click="handleEditCancel">取消</a-button>
				<a-button type="primary" :loading="submitLoading" @click="handleEditOk">提交</a-button>
			</template>
		</a-modal>
		<footer-btn
			v-if="basicInfoProps.curr_step_num<stepInfo.stepNum && canEdit"
			:btnText="btnText"
			:disabled-save-btn="disabledSaveBtn"
			@on-save="onSave"
			@on-cancel="onCancel"
		></footer-btn>
	</div>
</template>

<script>
import _ from "lodash";
import moment from "moment";
import {
  initDocOptions,
  modifyContract,
  addDoc,
  getContract
} from "../../services/DocService.js";

export default {
  props: {
    basicInfoProps: Object,
    canEdit: Boolean,
    stepInfo: Object
  },
  data() {
    return {
      createFormShow: true,
      showEditModal: false,
      loading: false,
      btnText: {
        cancelText: "重置",
        okText: "保存"
      },
      disabledSaveBtn: false,
      fieldOpts: [
        // {
        //   name: '是否使用cohort',
        //   field: 'cohort_situation',
        //   editable: 1,
        //   required: 0,
        //   tpl: 'select',
        //   options: [
        //     {
        //       option_id: 101,
        //       option_name: 'happy部',
        //     },
        //   ],
        // },
        // {
        //   name: '涉及癌种',
        //   field: 'ownership_dept',
        //   editable: 1,
        //   required: 0,
        //   tpl: 'select',
        //   options: [
        //     {
        //       option_id: 101,
        //       option_name: 'happy部',
        //     },
        //   ],
        // },
        // {
        //   name: '药品名称',
        //   field: 'cancer_species',
        //   editable: 1,
        //   required: 0,
        //   tpl: 'select',
        //   options: [
        //     {
        //       option_id: 101,
        //       option_name: 'happy部',
        //     },
        //   ],
        // },
        // {
        //   name: '起始时间',
        //   field: 'contract_start_date',
        //   editable: 1,
        //   required: 0,
        //   tpl: 'date',
        //   options: [],
        // },
        // {
        //   name: '终止时间',
        //   field: 'contract_stop_date',
        //   editable: 1,
        //   required: 0,
        //   tpl: 'date',
        //   options: [],
        // },
        // {
        //   name: '签约客户类型',
        //   field: 'customer_sign_type',
        //   editable: 0,
        //   required: 0,
        //   tpl: 'select',
        //   options: [],
        // },
        // {
        //   name: '最终客户信息',
        //   field: 'customer_final_info',
        //   editable: 0,
        //   required: 0,
        //   tpl: 'select',
        //   options: [],
        // },
        // {
        //   name: '付款条款',
        //   field: 'payment_items',
        //   editable: 0,
        //   required: 0,
        //   tpl: 'textarea',
        //   options: [],
        // },
        // {
        //   name: '合同内容描述',
        //   field: 'content_description',
        //   editable: 1,
        //   required: 0,
        //   tpl: 'textarea',
        //   options: [],
        // },
      ],
      fieldEditOpts: [],
      docBasicInfo: {},
      initNewData: {},
      initData: {},
      submitLoading: false,
    };
  },

  computed: {
    basicCardData() {
      const field_label = this.docBasicInfo.field_label;
      const contract_info = this.docBasicInfo.contract_info;
      const infos = [];
      if (field_label) {
        field_label.forEach((item, index) => {
          if (
            _.isObject(contract_info[item.field]) &&
            contract_info[item.field]
          ) {
            infos.push({
              label: item.label,
              key: item.field,
              value: contract_info[item.field].name
            });
          } else if (!_.isObject(contract_info[item.field])) {
            infos.push({
              label: item.label,
              key: item.field,
              value: contract_info[item.field]
            });
          }
        });
        const infoGroups = [];
        for (let i = 1; i <= Math.ceil(infos.length / infos.length); i += 1) {
          const item = infos.slice(
            (i - 1) * infos.length,
            (i - 1) * infos.length + infos.length
          );
          infoGroups.push(item);
        }
        return infoGroups;
      }
    },
    basicCardLayout() {
      return [
        {
          hasTitle: false,
          data: this.basicCardData
        }
      ];
    },
    loaded() {
      if (
        this.fieldEditOpts.length > 0 &&
        Object.keys(this.initData).length > 0
      ) {
        return true;
      } else {
        return false;
      }
    }
  },

  methods: {
    fetchFieldOpts() {
      initDocOptions({
        contract_type: this.basicInfoProps.contract_type,
        archival_status: this.basicInfoProps.archival_status,
        step_num: this.stepInfo.stepKey,
        new: 1
      }).then(res => {
        if (res.status === "success") {
          this.fieldOpts = res.data.field_options;
          this.fieldOptsBackup = _.cloneDeep(this.fieldOpts);
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    fetchFieldEditOpts() {
      initDocOptions({
        contract_type: this.basicInfoProps.contract_type,
        archival_status: this.basicInfoProps.archival_status,
        step_num: this.stepInfo.stepKey,
        new: 0
      }).then(res => {
        if (res.status === "success") {
          this.fieldEditOpts = res.data.field_options;
          this.fieldEditOptsBackup = _.cloneDeep(this.fieldEditOpts);
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    createDocChange(val) {
      let keys = Object.keys(val);
      if (!keys.length) {
        return;
      }
      let name = keys[0];
      const currFiledObj = this.fieldOpts.find(item => {
        return item.field === name;
      });
      if (moment.isMoment(val[name].value)) {
        if (currFiledObj.tpl === "month") {
          val[name].value = moment(val[name].value).format("YYYY-MM");
        } else {
          val[name].value = moment(val[name].value).format("YYYY-MM-DD");
        }
      }
      this.initNewData[name] = val[name].value;
      if (currFiledObj.target && currFiledObj.target !== "") {
        this.getTarget(
          currFiledObj.target,
          val[name].value,
          this.fieldOpts,
          this.fieldOptsBackup
        );
      }
    },
    editDocChange(val) {
      let keys = Object.keys(val);
      if (!keys.length) {
        return;
      }
      let name = keys[0];
      const currFiledObj = this.fieldEditOpts.find(item => {
        return item.field === name;
      });
      if (moment.isMoment(val[name].value)) {
        if (currFiledObj.tpl === "month") {
          val[name].value = moment(val[name].value).format("YYYY-MM");
        } else {
          val[name].value = moment(val[name].value).format("YYYY-MM-DD");
        }
      }
      this.initData[name] = val[name].value;
      if (currFiledObj.target && currFiledObj.target !== "") {
        this.getTarget(
          currFiledObj.target,
          val[name].value,
          this.fieldEditOpts,
          this.fieldEditOptsBackup
        );
      }
    },
    getTarget(targetField, parentVal, fieldOpts, fieldOptsBackup) {
      fieldOpts = _.cloneDeep(fieldOptsBackup);
      fieldOpts.forEach(item => {
        if (item.field === targetField) {
          item.options = item.options.filter(
            option => Number(option.parent_id) === parentVal
          );
        }
      });
    },
    fetchContractInfo() {
      if (this.basicInfoProps.curr_step_num < this.stepInfo.stepNum) {
        return;
      }
      this.loading = true;
      getContract({
        contract_id: this.basicInfoProps.contract_id,
        step_num: this.stepInfo.stepKey
      }).then(res => {
        if (res.status === "success") {
          this.docBasicInfo = res.data;
          this.initData = _.cloneDeep(res.data.contract_info);
          for (let key in this.initData) {
            if (_.isObject(this.initData[key])) {
              this.initData[key] = this.initData[key].id;
            }
          }
          this.initDataBackup = _.cloneDeep(this.initData);
        } else {
          this.$Message.error(res.message);
        }
        this.loading = false;
      });
    },
    handleCreateOk() {
      this.$refs.createForm.form.validateFields((err, fieldsValue) => {
        if (err) {
          return;
        }
        this.initNewData.contract_sn = this.basicInfoProps.contract_sn;
        addDoc({
          contract_type: this.basicInfoProps.contract_type,
          archival_status: this.basicInfoProps.archival_status,
          contrat_data: this.initNewData,
          step_num: this.stepInfo.stepKey
        }).then(res => {
          if (res.status === "success") {
            this.$emit("change-step", {
              curr_step_num: this.stepInfo.stepNum,
              next_step: this.stepInfo.nextStepNum
            });
            this.fetchContractInfo();
            this.$emit("update-doc");
          } else {
            this.$Message.error(res.message);
          }
        });
      });
    },
    onSave() {
      this.handleCreateOk();
    },
    onCancel() {
      this.initNewData = {};
      this.createFormShow = false;
      this.$nextTick(() => {
        this.createFormShow = true;
      });
    },
    onEdit(e) {
      this.initData = _.cloneDeep(this.initDataBackup);
      this.showEditModal = true;
    },
    handleEditCancel() {
      this.showEditModal = false;
    },
    handleEditOk() {
      this.$refs.editForm.form.validateFields((err, fieldsValue) => {
        if (err) {
          return;
        }
        this.initData.contract_sn = this.basicInfoProps.contract_sn;
        if (
          this.initData.customer_name &&
          this.initData.customer_name.indexOf("_") > -1
        ) {
          this.initData.customer_name = this.initData.customer_name.split(
            "_"
          )[0];
        }
        this.submitLoading = true;
        modifyContract({
          contrat_data: this.initData,
          step_num: this.stepInfo.stepKey
        }).then(res => {
          if (res.status === "success") {
            this.fetchContractInfo();
            this.$emit("update-doc");
            this.showEditModal = false;
          } else {
            this.$Message.error(res.message);
            this.showEditModal = false;
          }
          this.submitLoading = false;
        });
      });
    },
    initFieldOpts() {
      this.fieldEditOpts = _.cloneDeep(this.fieldEditOptsBackup);
      this.fieldEditOpts.forEach(item => {
        if (item.target && item.target !== "" && this.initData[item.field]) {
          let targetObj = this.fieldOpts.find(child => {
            return child.field === item.target;
          });
          targetObj.options = targetObj.options.filter(
            option => Number(option.parent_id) === this.initData[item.field]
          );
        }
      });
    }
  },
  created() {
    this.fetchFieldOpts();
    this.fetchFieldEditOpts();
    this.fetchContractInfo();
  },
  watch: {
    loaded(val) {
      if (val) {
        this.initFieldOpts();
      }
    },
    initData() {
      if (this.loaded) {
        this.initFieldOpts();
      }
    }
  }
};
</script>

<style lang="less">
.doc-abstract-info {
  &-form {
    width: 500px;
  }
}
</style>
